import React, { useEffect, useState } from "react";
import { node, bool, number, string } from "prop-types";
import cx from "classnames";

const propTypes = {
  children: node.isRequired,
  show: bool,
  duration: number,
  baseClass: string,
  exitClass: string,
  disableClass: string,
};

const TransitionWrapper = ({
  children,
  show,
  duration,
  baseClass,
  exitClass,
  disableClass,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setIsAnimating(true);
    } else if (isVisible) {
      setIsAnimating(true);

      const timer = setTimeout(() => {
        setIsVisible(false);
        setIsAnimating(false);
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [show, isVisible, duration]);

  if (!isVisible && !isAnimating) return null;

  return (
    <div
      className={cx(baseClass, disableClass, {
        [exitClass]: !show,
      })}
    >
      {children}
    </div>
  );
};

TransitionWrapper.propTypes = propTypes;
export default TransitionWrapper;
